<template>
  <!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :first="firstRecordIndex"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :rowsPerPageOptions="perPageOptions"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getBodyStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 80px; height: 80px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="c.type == 'Boolean'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectList(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>
        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else-if="getType(c) == 'MultiSelect'"  v-html="callbackDataMultiSelect( c ,slotProps.data)"></div>
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>


      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"

          @change="onFilter($event,c.filter.type,c.key)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <DropdownScrollable
          v-if="c.filter.type == 'SelectScroll'"
          :limit="options[c.key]?.limit"
          :loading="options[c.key]?.loading"
          v-model="filters[getField(c)]"
          :options="options[c.key]?.items"
          :total="options[c.key]?.total"
          onlyClick
          readonly
          @click="(value) => onEventOptions('click', c.key, value, c.filter)"
          @keyup="(value) => onEventOptions('keyup', c.key, value, c.filter)"
          @scroll="(value) => onEventOptions('scroll', c.key, value, c.filter)"
          @offset="(value) => onEventOptions('offset', c.key, value, c.filter)">
          <template #label="slotProps">
            <div class="p-clearfix">
              <span>{{ slotProps[c.filter.optionLabel] }}</span>
            </div>
          </template>
        </DropdownScrollable>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd" 
          :placeholder="getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          :style="getStyleCalendar(c.key)"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        {{ slotProps.data.color }}
        <span v-for="(a, k) in actions.rows(slotProps.data)" :key="k">
          <Button
            v-if="a.name == 'view'"
            type="button"
            :icon="getIcon(a.icon)"
            :class="getClass(a.name)"
            style="margin: 2px;width:30px;"
            v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
          <Button
            v-if="a.name == 'edit'"
            type="button"
            :icon="getIcon(a.icon)"
            :class="getClass(a.name)"
            :disabled="(slotProps.data.status !=='NEW' && slotProps.data.status !=='REJECTED')"
            style="margin: 2px;width:30px;"
            v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
          
          <Button
            v-if="a.name == 'delete'"
            type="button"
            :icon="getIcon(a.icon)"
            :class="getClass(a.name)"
            style="margin: 2px;width:30px;"
            v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
          <Button
            v-if="a.name == 'delete_fix'"
            type="button"
            :icon="getIcon(a.icon)"
            :class="getClass(a.name)"
            style="margin: 2px;width:30px;"
            v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
        </span>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      <div class="text-center">{{ $t('datatable.empty') }}</div>
    </template>
    <template #loading>
      <div class="text-center">{{ $t('datatable.loading') }}</div>
    </template>
    <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" >
      <h1 class="txt-center txt-required">HỆ THỐNG ĐANG PHÁT TRIỂN  !!!!!!!!!!!!!</h1>
    </Dialog>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  components:{
    DropdownScrollable
  },
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
    company: Object,
    factory_obj: Object,
    filterDefault: Object
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filtersCustom: {},
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
      yearRange : "2022:2300",
      time_zone_local : moment.tz.guess(true),
      popupWarning: false,
      company_id: null,
      lazyRequestId: 0
    };
  },
  computed: {
    perPageOptions() {
      // company_type = option_1 thì thêm lựa chọn 4 dòng / trang
      if (this.getCompanyType() == 'option_1') {
        return [4, ...this.$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS];
      }
      return this.$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS;
    },
  },
  watch: {
    async "this.$props.company"() {
        console.log("asdkajshdjkasd");
        // await this.onLazyEvent();
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        // await this.onLazyEvent();
      }
    },
  },
  async created() {
    // console.log("options==============",this.options)
    this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    // console.log("this.filterDefault==============",this.filterDefault)
    if (this.filterDefault !== undefined && this.filterDefault !== null) {
      this.filters = this.filterDefault;
      if(this.filterDefault['contractor_name']){
        this.filters['contractor_name'] = this.filterDefault['contractor_name'];
      }
      this.filtersCustom['contractor_name'] = this.filterDefault['contractor_name'];
      // this.filtersCustom = this.filterDefault;
    }
    this.restoreListState();
    var year = new Date().getFullYear()
    var yearRange = '2022:'+(year+100);
    this.yearRange = yearRange+''
    this.test = this.tableData;
  },
  mounted () {
    console.log("this.filters==",this.filters)
    // company_type = option_1 thì mặc định hiển thị 4 dòng / trang
    if (this.getCompanyType() == 'option_1') {
      this.paginationRows = 4;
    }
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    console.log("this.lazyParams:111111122222222222222",this.lazyParams);
    /*
    * stateStorage="session"
    stateKey="dt-state-demo-session"
    * phai them thuoc tinh nay vao table
    * */
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    // Điều kiện hiện tại của danh sách (filter, công ty, tổng số) để xuất excel
    getExportParams() {
      var filters = Object.assign({}, this.filtersCustom);
      if (this.factory?.id) {
        filters.factory_id = this.factory?.id;
      }
      var company_id = this.company?.id ?? null;
      if (this.$store.getters.type != this.$constants.TYPE_USER.SUPPER_ADMIN) {
        company_id = this.company_id ?? null;
      }
      return {filters: filters, company_id: company_id, total: this.totalRecords};
    },
    // Lưu/khôi phục điều kiện lọc để khi quay lại từ xóa/chi tiết/chỉnh sửa vẫn giữ nguyên
    saveListState() {
      try {
        sessionStorage.setItem('sra_list_state', JSON.stringify({
          filters: this.filters,
          filtersCustom: this.filtersCustom,
        }));
      } catch (e) { /* ignore */ }
    },
    restoreListState() {
      // vào từ link có contractor_id thì dùng filter mặc định, không khôi phục
      if (!this.$commonFuction.isEmpty(this.$route.query?.contractor_id)) return;
      try {
        var raw = sessionStorage.getItem('sra_list_state');
        if (!raw) return;
        var state = JSON.parse(raw);
        var isoDate = /^\d{4}-\d{2}-\d{2}T/;
        var filters = state.filters || {};
        Object.keys(filters).forEach(k => {
          if (Array.isArray(filters[k])) {
            filters[k] = filters[k].map(v => (typeof v === 'string' && isoDate.test(v)) ? new Date(v) : v);
          }
        });
        this.filters = filters;
        this.filtersCustom = state.filtersCustom || {};
      } catch (e) { /* ignore */ }
    },
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if(col.minWidth)style = "min-width: " + col.minWidth + "em;";
      else if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getBodyStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      // console.log("this.options:",this.options)
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("LL");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy HH:mm");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          // console.log("col.models:",col.models);
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else if(col.type == "Boolean"){
        value = (row[col.key]) ? `<i class="pi pi-check success bold"></i>` : `<i class="pi pi-times danger bold"></i>`;
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn`;
      } else if (col.filter.type == "input") {
        return `Nhập`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "delete_fix":
          return "p-button-delete-fix";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    redirectList(data, e) {
      let clickedElId = e.target.id
      if (clickedElId === 'list-users') {
      //   let id = data.id;
      //   let path = `/admin/list-users/${id}`;
      //   this.$router.push({path: path})
        this.popupWarning = true;
      }else if(clickedElId === 'list-atw'){
        let id = data.atw_id;
        let path = `/admin/list-atw/view/`+id+'?company_id='+this.company_id;
        // console.log("=============path",path)
        this.$router.push({path: path})
      }else if(clickedElId === 'daily-atw'){
        let id = data.last_daily_atw.id;
        let path = `/admin/daily-atw/view/`+id+'?company_id='+this.company_id;
        // console.log("=============path",path)
        this.$router.push({path: path})
      } else if(clickedElId === 'daily-sra'){
        let id = data.id;
        let path = '/';
        if(this.company_id){
          path = `/admin/daily-atw?company_id=`+this.company_id+'&sra_id='+id;
        }else{
          path = `/admin/daily-atw?company_id=`+this.company.id+'&sra_id='+id;
        }
        
        // console.log("=============path",path)
        this.$router.push({path: path})
      }
    },
    callbackCustomUrl(c,data){
      var text = ''
      // console.log(data);
      switch(c.key) {
        case 'users':
          text = '<a class="txt-link" id="list-users" :data-id="'+data.id+'">'+data.users+'</a>';
          break;
        case 'code':
          text = data.code;
          break;
        case 'hsdn':
          if(data.map_hsdn && data.map_hsdn.length > 0){
            let count_a = 0;
            for (let i = 0; i < data.map_hsdn.length; i++) {
              let e = data.map_hsdn[i];
              if(e.status == 'APPROVED'){//đã duyệt
                count_a++;
              }
            }
            text = count_a+'/'+data.map_hsdn.length
          }else{
            text = '0/0'
          }
          break;
        case 'nhansu':
          if(data.map_nhansu && data.map_nhansu.length > 0){
            let count_a = 0;
            for (let i = 0; i < data.map_nhansu.length; i++) {
              let e = data.map_nhansu[i];
              if(e.status == 'APPROVED'){//đã duyệt
                count_a++;
              }
            }
            text = count_a+'/'+data.map_nhansu.length
          }else{
            text = '0/0'
          }
          break;
        case 'vattu':
          if(data.map_vattu && data.map_vattu.length > 0){
            let count_a = 0;
            for (let i = 0; i < data.map_vattu.length; i++) {
              let e = data.map_vattu[i];
              if(e.status == 'APPROVED'){//đã duyệt
                count_a++;
              }
            }
            text = count_a+'/'+data.map_vattu.length
          }else{
            text = '0/0'
          }
          break;
        case 'thietbi':
          if(data.map_thietbi && data.map_thietbi.length > 0){
            let count_a = 0;
            for (let i = 0; i < data.map_thietbi.length; i++) {
              let e = data.map_thietbi[i];
              if(e.status == 'APPROVED'){//đã duyệt
                count_a++;
              }
            }
            text = count_a+'/'+data.map_thietbi.length
          }else{
            text = '0/0'
          }
          break;
        case 'hscd':
          var count_w = 0;
          if(data.map_hsdn && data.map_hsdn.length > 0){
            for (let i = 0; i < data.map_hsdn.length; i++) {
              let e = data.map_hsdn[i];
              if(e.status == 'WAITTING'){//đã duyệt
                count_w++;
              }
            }
          }
          if(data.map_nhansu && data.map_nhansu.length > 0){
            for (let i = 0; i < data.map_nhansu.length; i++) {
              let e = data.map_nhansu[i];
              if(e.status == 'WAITTING'){
                count_w++;
              }
            }
          }
          if(data.map_vattu && data.map_vattu.length > 0){
            for (let i = 0; i < data.map_vattu.length; i++) {
              let e = data.map_vattu[i];
              if(e.status == 'WAITTING'){
                count_w++;
              }
            }
          }
          if(data.map_thietbi && data.map_thietbi.length > 0){
            for (let i = 0; i < data.map_thietbi.length; i++) {
              let e = data.map_thietbi[i];
              if(e.status == 'WAITTING'){
                count_w++;
              }
            }
          }
          text = count_w
          break;
        case 'awt_html':
          if(data.atw_id ){
            if (this.$store.getters.controllers?.list_atw && this.$store.getters.controllers?.list_atw.includes('view')) {
              text = '<a class="txt-link" id="list-atw" :data-id="'+data.atw_id+'">'+data.atw_code+'</a>';
            }else{
              text = data.atw_code;
            }
          }
          break;
        case 'last_daily_atw_html':
          if(data.last_daily_atw){
            if (this.$store.getters.controllers?.daily_atw && this.$store.getters.controllers?.daily_atw.includes('view')) {
              text = '<a class="txt-link" id="daily-atw" :data-id="'+data.last_daily_atw.id+'">'+data.last_daily_atw.code+'</a>';
            }else{
              text = data.last_daily_atw.code;
            }
          }
          break;
        case 'count_daily_atw_html':
          var count_daily_atw = 0;
          if(this.getCompanyType() == 'option_1'){
            count_daily_atw = data.file_work_permit ? data.file_work_permit.length+'' : '0';
            text = count_daily_atw+'';
            break;
          }
          if (this.$store.getters.controllers?.daily_atw && this.$store.getters.controllers?.daily_atw.includes('view')) {
            text = '<a class="txt-link" id="daily-sra" :data-id="'+data.id+'">'+count_daily_atw+'</a>';
          }else{
            text = count_daily_atw+'';
          }

          break;
        case 'areas_html':
          if(data.map_areas && data.map_areas.length > 0){
            let areas_txt = '';
            for (let i = 0; i < data.map_areas.length; i++) {
              const e = data.map_areas[i];
              if(areas_txt != ''){
                areas_txt += '; '+e.areas?.name;
              }else{
                areas_txt += e.areas?.name;
              }
            }
            text = areas_txt;
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    getCompanyType() {
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        return this.company?.company_type ?? 'normal';
      }
      return this.$store.getters?.companyType ?? 'normal';
    },
    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'active_html':
          if(data.active === true){
            text += '<div style="text-align: center;"><i class="fa fa-solid fa-check" style="color: #00973D;"/></div>';
          }else{
            text += '<div style="text-align: center;"><i class="fa fa-solid fa-times" style="color: #E95D57;"/></div>';
          }
          break;
        case 'name_country':
          if(data.country && data.country.country_lang){
            for (let i = 0; i < data.country.country_lang.length; i++) {
              const el = data.country.country_lang[i];
              if(el.lang =='en'){
                text += el.name;
                break;
              }
            }
          }
          break;
        case 'factory_id':
          text = data?.factory_name;
          break;
        case 'risk_level' :
          var lev = data?.risk_level;
          if(lev == 'LOW'){
            text = '<div class="risk-cs-l">Thấp</div>'
          }else if(lev == 'MEDIUM'){
            text = '<div class="risk-cs-m">Trung bình</div>'
          }else if(lev == 'HIGH'){
            text = '<div class="risk-cs-h">Cao</div>'
          }
          break;
        default:
      }
      return text;
    },
   async dataList(lazyParams) {
      var filters = lazyParams.filters;
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.company_id ?? null;
      }
      if (this.factory?.id) {
        filters.factory_id = this.factory?.id;
      }
      var listData = [];
      var total = 0;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/sra/list", {filters, limit: lazyParams.rows, offset: lazyParams.first, company_id: company_id}, {headers}).then(function (response) {
            var data = response.data.data;
            listData = data.sra;
            total = data.total;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
     var dataRes = {
       listData: listData,
       total: total,
     };
    //  console.log("dataRessadasd",dataRes)
     return dataRes;
    },
    async onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      this.saveListState();
      // console.log('this.filtersCustom:',this.filtersCustom)
      this.loading = true;
      var that =this;
      this.lazyRequestId++;
      var requestId = this.lazyRequestId;
      await this.dataList(this.lazyParams).then(async data => {
        if (requestId !== that.lazyRequestId) {
          return;
        }
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
          let text_supervisor = ''
          if(data.listData[i].sra_supervisor){
            for (let j = 0; j < data.listData[i].sra_supervisor.length; j++) {
              const e = data.listData[i].sra_supervisor[j];
              if(text_supervisor !== ''){
                text_supervisor += '; '+e.fullname
              }else{
                text_supervisor = e.fullname
              }
            }
          }
          data.listData[i].text_supervisor = text_supervisor;
          if (data.listData[i].factory){
            data.listData[i].factory = data.listData[i].factory.name;
          }
          var safe_value_txt = ''
          var quality_value_txt = ''
          if(data.listData[i].sra_contractor_evaluate){
            if(data.listData[i].sra_contractor_evaluate.safe_value == 1){
              safe_value_txt = '-An toàn: Rất tệ'
            }else if(data.listData[i].sra_contractor_evaluate.safe_value == 2){
              safe_value_txt = '-An toàn: Tệ'
            }else if(data.listData[i].sra_contractor_evaluate.safe_value == 3){
              safe_value_txt = '-An toàn: Hoàn thành'
            }else if(data.listData[i].sra_contractor_evaluate.safe_value == 4){
              safe_value_txt = '-An toàn: Tốt'
            }else if(data.listData[i].sra_contractor_evaluate.safe_value == 5){
              safe_value_txt = '-An toàn: Rất tốt'
            }
            if(data.listData[i].sra_contractor_evaluate.quality_value == 1){
              quality_value_txt = '-Chất lượng: Rất tệ'
            }else if(data.listData[i].sra_contractor_evaluate.quality_value == 2){
              quality_value_txt = '-Chất lượng: Tệ'
            }else if(data.listData[i].sra_contractor_evaluate.quality_value == 3){
              quality_value_txt = '-Chất lượng: Hoàn thành'
            }else if(data.listData[i].sra_contractor_evaluate.quality_value == 4){
              quality_value_txt = '-Chất lượng: Tốt'
            }else if(data.listData[i].sra_contractor_evaluate.quality_value == 5){
              quality_value_txt = '-Chất lượng: Rất tốt'
            }
          }
          var text_custom = ''
          if(safe_value_txt){
            text_custom += safe_value_txt;
          }
          if(quality_value_txt){
            if(text_custom.length > 0){
              text_custom += '<br>';
            }
            text_custom += quality_value_txt;
          }
          data.listData[i].sra_evaluate_txt = text_custom;

          let text_time = ''
          if(data.listData[i].date_start){
            text_time = this.$commonFuction.customFormatDate(data.listData[i].date_start);
          }else{
            text_time = '?'
          }
          if(data.listData[i].date_end){
            text_time += '-'+this.$commonFuction.customFormatDate(data.listData[i].date_end);
          }else{
            text_time = '-?'
          }
          data.listData[i].time_sra = text_time
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event,type_input,key){
      //this.loading = true;
      this.tableData = this.test;
      if(type_input == "DateRange"){
        if(this.filters[key] !== null && this.filters[key][1]== null){
          return false;
        }
      }
      // this.filtersCustom[key] = {
      //   type_input:type_input,
      //   value:this.filters[key],
      // };
      console.log('this.filters:',this.filters);
      var filter = await this.$CoreService.convertFilter(type_input,key,this.filters);
      this.filtersCustom[key] = filter?.value;
      if(type_input == "SelectScroll"){
        if (event != 'click') {
          return;
        }
        if (key == 'factory') {
          this.filtersCustom[key] = this.filtersCustom[key]?.id;
        }
      }
      // this.filtersCustom.append(this.filtersCustom[key]);
      // console.log(this.filtersCustom);
      this.lazyParams.first = 0;
      await this.onLazyEvent()
      /*setTimeout(() => {
        this.customers = this.datasource.slice(event.first, event.first + event.rows);
        this.loading = false;
      }, 500);*/
    },
    getStyleCalendar(key){
      if(key == 'time_sra'){
        return 'width: 100%;';
      }else{
        return 'width:100%;';
      }
    },
    async onEventOptions(e, key, data, filter) {
      if (this.options[key]?.filters) {
        this.$delete(this.options[key].filters, filter.optionLabel);
      }
      if (data) {
        this.options[key].filters[filter.optionLabel] = data;
      }
      this.$emit("onEventOptions", {event: e, key:key, data: this.options[key]});
      if (e == 'click') {
        await this.onFilter(e,filter.type,key);
      }
    },
    callbackDataMultiSelect(c,data){
      var text = "";
      //console.log('Data here:' ,data);
      switch(c.key) {
        case 'factory':
          if (data.factory_id && data.factory) {
            text+= `<div style="min-with:90px">${data.factory}</div>`;
          } else {
            console.error('Data factory is missing or incomplete');
          }
          break;
        default:
      }
      return text;
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
/* .p-column-filter{
  width: 100%;
} */
.p-button-label-o{
  color : white;
}
.txt-required{
  color : red;
}

.risk-cs-l {
  background-color: yellow;
  border-radius: 5px;
  /* color: white; */
}
.risk-cs-m {
  background-color: orange;
  border-radius: 5px;
  color: white;
}
.risk-cs-h {
  background-color: red;
  border-radius: 5px;
  color: white;
}
</style>